// extracted by mini-css-extract-plugin
export default {"searchRedirectButton":"Home_searchRedirectButton__8Efa1"};